import { FormData } from '@netsyde/react-forms'
import { Claim, ClaimJson, parseClaimJson, ValidationResult } from 'portal2-models'
import { trimBlankClaimSubForms } from 'portal2-claim'
import { camelCaseValidationErrors } from './common'
import { errorHandlerCallback, userDataRefreshCallback } from './index'
import { wrappedFetch as fetch } from './wrappedFetch'

export function stripEnrolmentData(claim: FormData<Claim>): FormData<Claim> {
	const stripped: FormData<Claim> = Object.assign({}, claim)

	// these are hydrated at the server end during submissions, and refreshed at the client end during editing
	const enrolmentKeys: Array<keyof Claim> = ['primaryPhone', 'emailAddress', 'addressLine1', 'addressLine2', 'cityTown', 'provinceId', 'province', 'postalCode', 'operationLegalName']

    enrolmentKeys.forEach(k => delete stripped[k])

	return stripped
}

export const getUserClaims = async () => {
	let claims: Array<FormData<Claim>> = []

	try {
		const response = await fetch('/api/claims/userclaims')
		const claimsJson = await response.json() as Array<FormData<ClaimJson>>
		claims = claimsJson.map(parseClaimJson)
	}
	catch {
		claims = []
		console.error("Failed to retrieve claims from server")
	}

	return claims
}

export const saveClaim = async (claimInput: FormData<Claim>, doSubmit = false) => {
	let claim = trimBlankClaimSubForms(claimInput)
	claim = stripEnrolmentData(claim)


	let validationResponse: ValidationResult<FormData<Claim>> = { isValid: false, model: claim, validationErrors: [] }

	const apiPath = doSubmit ? '/api/claims/submit' : '/api/claims/save'

	try {
		const response = await fetch(apiPath, {
			method: 'POST',
			body: JSON.stringify(claim), 
			headers: {'Content-Type': 'application/json'}
		})

		const serverValidationResponse = await response.json() as ValidationResult<FormData<any>>
		const validationResponseJson: ValidationResult<FormData<ClaimJson>> = camelCaseValidationErrors(serverValidationResponse)

		// TODO: check why we have to cast here
		validationResponse = { ...validationResponseJson, model: parseClaimJson(validationResponseJson.model) } as any as ValidationResult<FormData<Claim>>

		if (validationResponse.isValid) {
			userDataRefreshCallback && await userDataRefreshCallback()
		}
		// TODO: eliminate this once we have validation field display working
		// else errorHandlerCallback && errorHandlerCallback(createErrorValidationError(validationResponse))

	}
	catch (err) {
		errorHandlerCallback ? errorHandlerCallback(err) : console.error("Failed to save claim at server")
	}

	return validationResponse
}
